import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import { showErrors, showNotification } from '@/utils/snack';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue';
import AppSearchBtn from '@/components/AppSearchBtn.vue';
import AppSimpleDistrictSelector from '@/components/AppSimpleDistrictSelector.vue';
import { findSchools } from '@/views/SchoolList/gql';
import { SchoolsOrderBy } from '@/interfaces/school';
import { findDealer } from '@/views/DealerList/gql';
import { updateDealerSchools } from '../gql';
import { SnackType } from '@/interfaces/snack';
Component.registerHooks(['beforeRouteLeave']);

var EditDealerSchool = /*#__PURE__*/function (_Vue) {
  _inherits(EditDealerSchool, _Vue);

  var _super = _createSuper(EditDealerSchool);

  function EditDealerSchool() {
    var _this;

    _classCallCheck(this, EditDealerSchool);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [{
      text: '经销商管理'
    }, {
      text: '经销商',
      to: {
        name: 'DealerList'
      }
    }];
    _this.windowSize = {
      w: 0,
      h: 0
    };
    _this.disabledActions = true;
    _this.actionsHeight = 51;
    _this.totalNum = 0;
    _this.loading = false;
    _this.headers = [{
      text: '学校',
      value: 'name'
    }];
    _this.selectedSchools = [];
    _this.options = {
      sortBy: ['name'],
      sortDesc: [true]
    };
    _this.filter = {};
    _this.dealerId = '';
    _this.dealerName = '';
    _this.schools = [];
    _this.allSchools = [];
    return _this;
  }

  _createClass(EditDealerSchool, [{
    key: "selectSchools",
    value: function selectSchools(val) {
      if (val.length > 0) {
        this.disabledActions = false;
      } else {
        this.disabledActions = true;
      }
    }
  }, {
    key: "mounted",
    value: function () {
      var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = this.$route.params.id;
                this.dealerId = id;
                _context.next = 4;
                return this.getDealerById(Number(this.dealerId));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "filterQuerySubmit",
    value: function filterQuerySubmit() {
      var area = this.filter.area;
      this.getSchoolByArea(Number(area.id));
    }
  }, {
    key: "getSchoolByArea",
    value: function () {
      var _getSchoolByArea = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.loading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return this.$apollo.query({
                  query: findSchools,
                  variables: {
                    order: {
                      by: SchoolsOrderBy.name,
                      asc: true
                    },
                    paging: {
                      skip: 0,
                      take: 1000
                    },
                    where: {
                      areaId: id
                    }
                  }
                });

              case 4:
                result = _context2.sent;

                if (result) {
                  this.allSchools = result.data.findSchools.schools;
                  this.totalNum = this.filterSchools.length;
                  this.loading = false;
                }

                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                typedError = _context2.t0;
                showErrors(typedError.graphQLErrors);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 8]]);
      }));

      function getSchoolByArea(_x) {
        return _getSchoolByArea.apply(this, arguments);
      }

      return getSchoolByArea;
    }()
  }, {
    key: "addManageSchoolConfirm",
    value: function () {
      var _addManageSchoolConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var selectIds, ids, result, typedError;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                selectIds = this.selectedSchools.map(function (item) {
                  return item.id;
                });
                ids = this.schools.map(function (item) {
                  return item.id;
                });
                _context3.prev = 2;
                _context3.next = 5;
                return this.$apollo.mutate({
                  mutation: updateDealerSchools,
                  variables: {
                    dealerId: Number(this.dealerId + ''),
                    schoolIds: ids === null || ids === void 0 ? void 0 : ids.concat(selectIds)
                  }
                });

              case 5:
                result = _context3.sent;

                if (result) {
                  showNotification({
                    msg: '分配成功',
                    type: SnackType.Info
                  });
                  this.disabledActions = true;
                  this.$router.go(-1);
                }

                _context3.next = 13;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](2);
                typedError = _context3.t0;
                showErrors(typedError.graphQLErrors);

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 9]]);
      }));

      function addManageSchoolConfirm() {
        return _addManageSchoolConfirm.apply(this, arguments);
      }

      return addManageSchoolConfirm;
    }()
  }, {
    key: "getDealerById",
    value: function () {
      var _getDealerById = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dealerId) {
        var result, dealer, typedError;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.$apollo.query({
                  query: findDealer,
                  variables: {
                    dealerId: dealerId
                  }
                });

              case 3:
                result = _context4.sent;

                if (result) {
                  dealer = result.data.findDealer;
                  this.schools = dealer === null || dealer === void 0 ? void 0 : dealer.schools;
                  this.dealerId = (dealer === null || dealer === void 0 ? void 0 : dealer.id) + '';
                  this.dealerName = (dealer === null || dealer === void 0 ? void 0 : dealer.realname) + '';
                  this.breadcrumbs = [{
                    text: '经销商管理'
                  }, {
                    text: '经销商',
                    to: {
                      name: 'DealerList'
                    }
                  }, {
                    text: "".concat(this.dealerName),
                    to: {
                      name: 'DealerDetail',
                      params: {
                        id: "".concat(this.dealerId)
                      }
                    }
                  }, {
                    text: '经营学校'
                  }];
                }

                _context4.next = 11;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);
                typedError = _context4.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));

      function getDealerById(_x2) {
        return _getDealerById.apply(this, arguments);
      }

      return getDealerById;
    }()
  }, {
    key: "onResize",
    value: function onResize() {
      this.windowSize = {
        w: window.innerWidth,
        h: window.innerHeight
      };
      var actionDom = this.$refs.actions;
      this.actionsHeight = actionDom.clientHeight;
    }
  }, {
    key: "beforeRouteLeave",
    value: function () {
      var _beforeRouteLeave = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(to, from, next) {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.disabledActions) {
                  res = confirm('页面修改尚未保存，是否确定要离开？');
                  next(res);
                } else {
                  next();
                }

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function beforeRouteLeave(_x3, _x4, _x5) {
        return _beforeRouteLeave.apply(this, arguments);
      }

      return beforeRouteLeave;
    }()
  }, {
    key: "filterSchools",
    get: function get() {
      var _this2 = this;

      return this.allSchools.filter(function (item) {
        return !_this2.schools.some(function (ele) {
          return ele.id === item.id;
        });
      });
    }
  }]);

  return EditDealerSchool;
}(Vue);

__decorate([Watch('selectedSchools', {
  deep: true,
  immediate: true
})], EditDealerSchool.prototype, "selectSchools", null);

EditDealerSchool = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppRefreshAndExport: AppRefreshAndExport,
    AppSearchBtn: AppSearchBtn,
    AppSimpleDistrictSelector: AppSimpleDistrictSelector
  }
})], EditDealerSchool);
export default EditDealerSchool;